import styled from '@emotion/styled'

export const DescriptionWrapper = styled.div`
  display: flex;
  align-self: stretch;
  justify-content: center;
  width: 100%;
`

export const DescriptionContent = styled.div`
  align-content: left;
  width: auto;
`

export const FooterContentWrapper = styled.div`
  width: 100%;
`
